import React, { useState, useEffect, useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import apiUrl from "../Apiurl";
import UltimeModificheUtente from "./UltimeModificheUtente";
import UltimeModificheUtenteCard from "./UltimeModificheUtenteCard";

function UltimeModificheSchermataPrinc(props) {
  const utente = props.utente;
  const setProductFunction = props.setProductFunction;
  const usernameCorrente = utente?.username;

  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [lista, setLista] = useState([]);
  const [selectedUtente, setSelectedUtente] = useState("");
  const [conteggiUtenti, setConteggiUtenti] = useState({});
  const [brandsPerUtente, setBrandsPerUtente] = useState({});
  const data1 = props.data1;
  const data2 = props.data2;
  const setData1 = props.setData1;
  const setData2 = props.setData2;

  const misure = {
    vs: 80,
    shortname: 300,
    brand: 150,
    data: 140,
  };

  useEffect(() => {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }

    fetch(
      apiUrl +
        "/prodotti/get/utentiCheHannoModificatoDiRecente/" +
        data1 +
        "/" +
        data2,
      { headers: { Authorization: "Bearer " + token } }
    )
      .then((resp) => resp.json())
      .then((data) => {
        setConteggiUtenti({});
        setBrandsPerUtente({});
        setLista(data);
        console.log("data.length", data.length);
      });
  }, [token]);

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    if (!lista.length) {
      setSelectedUtente("");
      return;
    }
    const nomi = lista
      .map((item) => (typeof item === "string" ? item : item.utente))
      .filter(Boolean);

    if (!nomi.length) {
      setSelectedUtente("");
      return;
    }

    setSelectedUtente((prevSelezionato) => {
      if (prevSelezionato && nomi.includes(prevSelezionato)) {
        return prevSelezionato;
      }
      if (usernameCorrente && nomi.includes(usernameCorrente)) {
        return usernameCorrente;
      }
      return nomi[0];
    });
  }, [lista, usernameCorrente]);

  const handleListaAggiornata = useCallback((nome, dati) => {
    const righe = Array.isArray(dati) ? dati : [];
    const uniqueBrands = [];
    righe.forEach((item) => {
      const brand = item?.brand;
      if (brand && !uniqueBrands.includes(brand)) {
        uniqueBrands.push(brand);
      }
    });

    setConteggiUtenti((prev) => {
      const numeroElementi = righe.length;
      if (prev[nome] === numeroElementi) {
        return prev;
      }
      return { ...prev, [nome]: numeroElementi };
    });

    setBrandsPerUtente((prev) => {
      const precedenti = prev[nome] ?? [];
      if (
        precedenti.length === uniqueBrands.length &&
        precedenti.every((val, idx) => val === uniqueBrands[idx])
      ) {
        return prev;
      }
      return { ...prev, [nome]: uniqueBrands };
    });
  }, []);

  function handleChangeData1(evt) {
    setData1(evt.target.value);
  }

  function handleChangeData2(evt) {
    setData2(evt.target.value);
  }

  function submitDate() {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }

    fetch(
      apiUrl +
        "/prodotti/get/utentiCheHannoModificatoDiRecente/" +
        data1 +
        "/" +
        data2,
      { headers: { Authorization: "Bearer " + token } }
    )
      .then((resp) => resp.json())
      .then((data) => {
        setConteggiUtenti({});
        setBrandsPerUtente({});
        setLista(data);
      });
  }

  return (
    <div className="sfondoColChiaro pb4">
      <div className="center mw9 w-100 pa3">
        <div className="pt3 tc pa3 br3 sfondoBiancoTema mb3">
          <span>Da data: </span>
          <input
            type="date"
            onChange={handleChangeData1}
            value={data1}
            /* style={stilePulsanti.inputClasses} */
          ></input>
          <span> a data: </span>
          <input type="date" onChange={handleChangeData2} value={data2}></input>
          <button className="ml2" onClick={submitDate}>
            Cerca
          </button>
        </div>
        <div className="flex flex-column flex-row-ns">
          <div className="w-100 w-third-ns pr0 mb3 mb0-ns">
            <div className="w-100 colonna85vh sezioneConScroll br3">
              {lista.length === 0 ? (
                <p className="tc">
                  Nessuna modifica trovata nel periodo selezionato.
                </p>
              ) : (
                lista.map((doc) => {
                  const nome = typeof doc === "string" ? doc : doc.utente;
                  if (!nome) {
                    return null;
                  }
                  return (
                    <UltimeModificheUtenteCard
                      key={nome}
                      nomeUtente={nome}
                      utenteCorrente={utente}
                      count={conteggiUtenti[nome]}
                      brands={brandsPerUtente[nome]}
                      isSelected={selectedUtente === nome}
                      onSelect={setSelectedUtente}
                    />
                  );
                })
              )}
            </div>
          </div>
          <div className="w-100 w-two-thirds-ns pl0 pl3-ns">
            {lista.length === 0 ? (
              <div className="tc pa3 sfondoBiancoTema br3 shadow-1">
                Seleziona un intervallo di date e premi &quot;Cerca&quot; per
                visualizzare le modifiche.
              </div>
            ) : (
              lista.map(function (doc) {
                const nome = typeof doc === "string" ? doc : doc.utente;
                if (!nome) {
                  return null;
                }
                return (
                  <div
                    key={nome}
                    className={selectedUtente === nome ? "" : "dn"}
                  >
                    <UltimeModificheUtente
                      misure={misure}
                      utente={utente}
                      nomeUtente={nome}
                      setProductFunction={setProductFunction}
                      data1={data1}
                      data2={data2}
                      onListaAggiornata={handleListaAggiornata}
                    />
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UltimeModificheSchermataPrinc;
